import React from "react";
import MainForm from "../content/main_form/MainForm";
import StepsPostulation from "../../steps_postulation/StepsPostulation";
import { STEPS } from "@frontend/constants/initialValues";

const index = ({languages,selection_process, tests, testsAvailable, enterpriseTruoraActivation = false, readonly=false}) => {

  return (
    <div>
      <StepsPostulation steps={STEPS} current={1}/>
      <MainForm
        selection_process={selection_process}
        languages={languages}
        tests={tests}
        enterpriseTruoraActivation={enterpriseTruoraActivation}
        testsAvailable={testsAvailable}
        readonly={readonly}
      />
    </div>
  );
};

export default index;
